var _path, _mask, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferenda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70944 12.6725C3.89942 12.4508 4.17677 12.3232 4.4687 12.3232H14.907C15.1989 12.3232 15.4763 12.4508 15.6662 12.6725L17.9607 15.3493C18.5167 15.998 18.0558 17.0001 17.2015 17.0001H2.17422C1.31987 17.0001 0.858958 15.998 1.41496 15.3493L3.70944 12.6725Z",
    fill: "#C2CFE0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_140378_679",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.24072,
    y: 8.80786,
    width: 12.554,
    height: 9.35378,
    rx: 0.5,
    transform: "rotate(-44.5554 2.24072 8.80786)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.24072,
    y: 8.80786,
    width: 12.554,
    height: 9.35378,
    rx: 0.5,
    transform: "rotate(-44.5554 2.24072 8.80786)",
    stroke: "#C2CFE0",
    strokeWidth: 2.6,
    mask: "url(#path-2-inside-1_140378_679)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 8.00192L8.96257 8.96217L12.3234 5.60132",
    stroke: "#C2CFE0",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenda);
export default __webpack_public_path__ + "static/media/referenda.79ae4144eb9c197845cc7ca20755fd82.svg";
export { ForwardRef as ReactComponent };